import { render, staticRenderFns } from "./StoreItems.vue?vue&type=template&id=e2065410&scoped=true"
import script from "./StoreItems.vue?vue&type=script&lang=js"
export * from "./StoreItems.vue?vue&type=script&lang=js"
import style0 from "./StoreItems.vue?vue&type=style&index=0&id=e2065410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2065410",
  null
  
)

export default component.exports